import {axiosInstance} from "../helpers/axios";

const userAgent = window.navigator.userAgent;

const getAssignedCommercialSupport = (data) => {
    return axiosInstance.post('getAssignedCommercialSupport/', data )
    .then((res) => {
        const data = res.data;
        return data;
    }).
    catch(err => {
        console.log("error");
        console.log(err.message);
    });
}

export default { getAssignedCommercialSupport };